import React from 'react';
import PropTypes from 'prop-types';

import { TextArea } from 'semantic-ui-react';
import { useTranslation } from 'react-i18next';

const _stringify = json => JSON.stringify(json, null, 4);

export default function JSONInput({ value, style = {}, onChange = () => {} }) {
    const [error, setError] = React.useState(false);
    const [json, setJSON] = React.useState(_stringify(value));

    const { t } = useTranslation();

    React.useEffect(() => {
        setJSON(_stringify(value));
    }, [value]);

    let extra_props = {};

    // this handles corontrolled/uncontrolled
    if (json !== undefined) {
        extra_props.value = json;
    }

    let overridden_style = { ...style };
    if (error) {
        overridden_style.border = '1px solid red';
    }

    const change = React.useCallback(
        ({ target: { value } }) => {
            setJSON(value);
            try {
                let parsed = JSON.parse(value);
                onChange(parsed);
                setError(false);
                return;
            } catch (e) {
                setError(true);
            }
        },
        [onChange]
    );

    return (
        <React.Fragment>
            <TextArea style={overridden_style} onChange={change} {...extra_props} />
            {error && t('ticket.common.error.malformed_json')}
        </React.Fragment>
    );
}

JSONInput.propTypes = {
    value: PropTypes.object,
    style: PropTypes.string,
    onChange: PropTypes.func
};
